import { TypographyOptions } from '@mui/material/styles/createTypography';
import { fontSizes, lineHeights } from './variables';

declare module '@mui/material/styles' {
  interface TypographyVariants {
    logo: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    logo?: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    logo: true;
  }
}

const typography: TypographyOptions = {
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    'Segoe UI',
    'Roboto',
    'Helvetica Neue',
    'Arial',
    'Noto Sans',
    'sans-serif',
    'Apple Color Emoji',
    'Segoe UI Emoji',
    'Segoe UI Symbol',
    'Noto Color Emoji',
  ].join(','),
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  logo: {
    fontFamily: 'Qualy, sans-serif',
    fontWeight: 700,
    fontSize: '2rem',
    letterSpacing: '0.02em',
    textTransform: 'none',
    color: '#fff'
  },
  h1: {
    fontWeight: 300,
    fontSize: '2.5rem',  // 40px
    lineHeight: lineHeights.tight,
    letterSpacing: '-0.01562em',
  },
  h2: {
    fontWeight: 300,
    fontSize: '2rem',    // 32px
    lineHeight: lineHeights.tight,
    letterSpacing: '-0.00833em',
  },
  h3: {
    fontWeight: 400,
    fontSize: '1.75rem', // 28px
    lineHeight: lineHeights.normal,
    letterSpacing: '0em',
  },
  h4: {
    fontWeight: 400,
    fontSize: '1.5rem',  // 24px
    lineHeight: lineHeights.normal,
    letterSpacing: '0.00735em',
  },
  h5: {
    fontWeight: 400,
    fontSize: '1.25rem', // 20px
    lineHeight: lineHeights.normal,
    letterSpacing: '0em',
  },
  h6: {
    fontWeight: 500,
    fontSize: '1rem',    // 16px
    lineHeight: lineHeights.normal,
    letterSpacing: '0.0075em',
  },
  subtitle1: {
    fontSize: fontSizes.lg,
    lineHeight: lineHeights.normal,
    letterSpacing: '0.00938em',
  },
  subtitle2: {
    fontSize: fontSizes.base,
    lineHeight: lineHeights.normal,
    letterSpacing: '0.00714em',
  },
  body1: {
    fontSize: fontSizes.base,
    lineHeight: lineHeights.normal,
    letterSpacing: '0.00938em',
  },
  body2: {
    fontSize: fontSizes.sm,
    lineHeight: lineHeights.normal,
    letterSpacing: '0.01071em',
  },
  button: {
    fontSize: fontSizes.sm,
    lineHeight: lineHeights.normal,
    letterSpacing: '0.02857em',
    textTransform: 'none',
    fontWeight: 500,
  },
  caption: {
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.normal,
    letterSpacing: '0.03333em',
  },
  overline: {
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.normal,
    letterSpacing: '0.08333em',
    textTransform: 'uppercase',
    fontWeight: 500,
  },
} as const;

export default typography; 